import {
    NATIONAL
    , INTERNATIONAL
} from '@/common/constants/ticket-types'

// ## tipo de tiquetes puede pedir
const utibacTicket = [
    'sin tiquetes'
]
const utibac = ( values = [] ) => {
    const noPermit = [
        NATIONAL
        , INTERNATIONAL
    ]
    return values.map(item => {
        if (noPermit.includes(item.value_send)) {
            return {
                ...item
                , message: 'Actualmente no se permiten'
            }
        }
        if (item.value_send === 'no_aplica') {
            return {
                ...item
                , message: 'Recuerda que para el sindicato Utibac solo se gestionan los permisos sin tiquetes y tienes :value días gestionar los permisos, sino se aprobaran automaticamente'
            }
        }
        return item
    })
}

// # listado de sindicatos que exigen terminos personalizados
const values = {
    'utibac': utibac
    ,'ticket-utibac': utibacTicket
}

export {
    values
}